export interface GossipCard {
  id: number;
  title: string;
  excerpt: string;
  cat: string;
  time: string;
  heat: string;
  trend: boolean;
  fresh: boolean;
  img: string;
}

export interface Channel {
  id: string;
  name: string;
  desc: string;
  count: string;
  icon: string;
}

export interface RankItem {
  id: number;
  title: string;
  cat: string;
  heat: string;
  delta: string;
  up: boolean;
}

export interface Pillar {
  icon: string;
  title: string;
  text: string;
}

export interface Quote {
  name: string;
  role: string;
  text: string;
}

export interface Faq {
  q: string;
  a: string;
}

export const heroStats = [
  { value: "268", label: "今日解锁瓜料" },
  { value: "24h", label: "全时段跟进" },
  { value: "0元", label: "永久免费畅享" },
];

export const channels: Channel[] = [
  { id: "variety", name: "综艺名场面", desc: "真人秀高光与翻车瞬间一网打尽", count: "1.2w", icon: "ri-star-line" },
  { id: "star", name: "明星红毯局", desc: "造型玄学、站位八卦与热搜背后", count: "9800", icon: "ri-camera-line" },
  { id: "film", name: "影视幕后", desc: "选角、剪辑、宣发的片场二三事", count: "1.1w", icon: "ri-film-line" },
  { id: "live", name: "直播现场", desc: "带货复盘与弹幕名场面实录", count: "7600", icon: "ri-video-line" },
  { id: "feel", name: "情感观察局", desc: "恋综分析与圈内感情线拆解", count: "8800", icon: "ri-heart-line" },
  { id: "biz", name: "商界瓜铺", desc: "明星生意、资本局与流量账本", count: "5300", icon: "ri-briefcase-line" },
];

export const hotCards: GossipCard[] = [
  {
    id: 1,
    cat: "综艺",
    title: "《全员躲猫猫》名场面：嘉宾三句话，让导演当场喊停",
    excerpt: "本该轻松搞笑的环节，被一句即兴发挥带偏画风，现场导演无奈抬手叫停，弹幕却集体起立鼓掌。",
    time: "今日 14:32",
    heat: "9.6w",
    trend: true,
    fresh: true,
    img: "https://readdy.ai/api/search-image?query=editorial%20illustration%20of%20a%20bright%20entertainment%20variety%20show%20studio%20stage%20set%20with%20warm%20stage%20lights%20confetti%20and%20a%20clapperboard%20on%20a%20soft%20cream%20background%20subtle%20film%20grain%20muted%20tomato%20red%20and%20fresh%20green%20accents%20soft%20lighting%20no%20people%20no%20text%20high%20detail%20stylish%20magazine%20art&width=900&height=600&seq=feed-variety-01&orientation=landscape",
  },
  {
    id: 2,
    cat: "明星",
    title: "红毯合照站位玄学：顶流每次都能站 C 位，真的只是巧合？",
    excerpt: "同场争奇斗艳，最后成片却各有姿态。造型师与粉丝都在复盘：站位背后到底藏了哪些小心思。",
    time: "今日 13:05",
    heat: "8.8w",
    trend: true,
    fresh: false,
    img: "https://readdy.ai/api/search-image?query=editorial%20illustration%20of%20a%20glamorous%20red%20carpet%20moment%20with%20warm%20spotlights%20a%20pair%20of%20sleek%20sunglasses%20gold%20star%20confetti%20and%20film%20frames%20on%20a%20soft%20cream%20background%20subtle%20film%20grain%20muted%20tomato%20red%20amber%20and%20green%20accents%20no%20people%20no%20text%20soft%20lighting%20high%20detail%20magazine%20art&width=900&height=600&seq=feed-star-02&orientation=landscape",
  },
  {
    id: 3,
    cat: "影视",
    title: "杀青一年才定档？幕后剪辑爆料：这片子前后改了三版结局",
    excerpt: "从开放到闭合，从温情到悬疑，片方为什么反复推翻？剪辑老师一句“预算和档期说了算”信息量拉满。",
    time: "昨日 21:18",
    heat: "7.2w",
    trend: false,
    fresh: false,
    img: "https://readdy.ai/api/search-image?query=editorial%20illustration%20of%20a%20behind%20the%20scenes%20film%20production%20scene%20with%20a%20director%20clapperboard%20vintage%20film%20reel%20and%20cinema%20camera%20on%20a%20soft%20cream%20background%20subtle%20film%20grain%20muted%20tomato%20red%20and%20warm%20amber%20accents%20no%20people%20no%20text%20soft%20lighting%20high%20detail%20magazine%20art&width=900&height=600&seq=feed-film-03&orientation=landscape",
  },
  {
    id: 4,
    cat: "直播",
    title: "带货翻车现场复盘：一句口误，让弹幕整屏刷起“退退退”",
    excerpt: "价格标错、尺码混乱，再敬业的主播也挡不住观众集体起哄。这场复盘把“脚本为何失控”讲明白了。",
    time: "昨日 19:40",
    heat: "6.5w",
    trend: false,
    fresh: false,
    img: "https://readdy.ai/api/search-image?query=editorial%20illustration%20of%20a%20cozy%20livestream%20studio%20desk%20with%20a%20glowing%20ring%20light%20microphone%20and%20computer%20screen%20showing%20colorful%20audio%20waves%20on%20a%20soft%20cream%20background%20subtle%20film%20grain%20muted%20tomato%20red%20and%20green%20accents%20no%20people%20no%20text%20soft%20lighting%20high%20detail%20magazine%20art&width=900&height=600&seq=feed-live-04&orientation=landscape",
  },
  {
    id: 5,
    cat: "情感",
    title: "恋综观察室神预言：导师当初那句话，如今竟全被应验",
    excerpt: "三个月前的一句点评被翻出来，跟如今结局逐条对上。网友直呼“情感导师的显微镜在哪买”。",
    time: "昨日 16:22",
    heat: "8.1w",
    trend: true,
    fresh: false,
    img: "https://readdy.ai/api/search-image?query=editorial%20illustration%20of%20two%20warm%20coffee%20cups%20facing%20each%20other%20with%20soft%20bokeh%20heart%20shapes%20floating%20above%20on%20a%20soft%20cream%20background%20subtle%20film%20grain%20muted%20tomato%20red%20and%20rose%20amber%20accents%20no%20people%20no%20text%20soft%20lighting%20high%20detail%20magazine%20art&width=900&height=600&seq=feed-love-05&orientation=landscape",
  },
  {
    id: 6,
    cat: "财经",
    title: "明星品牌一年做到千万流水：流量变现的账，其实没那么玄",
    excerpt: "从供应链到情绪定价，从联名到直播。拆开来看，明星生意跟普通品牌差在流量，也差在踩坑速度。",
    time: "周二 10:15",
    heat: "5.4w",
    trend: false,
    fresh: false,
    img: "https://readdy.ai/api/search-image?query=editorial%20illustration%20of%20rising%20golden%20arrow%20graphs%20over%20stacked%20coins%20and%20a%20small%20office%20building%20silhouette%20on%20a%20soft%20cream%20background%20subtle%20film%20grain%20muted%20tomato%20red%20amber%20and%20green%20accents%20no%20people%20no%20text%20soft%20lighting%20high%20detail%20magazine%20art&width=900&height=600&seq=feed-biz-07&orientation=landscape",
  },
  {
    id: 7,
    cat: "综艺",
    title: "综艺考古局：被遗忘的三年前神级现场，如今热度逆袭翻红",
    excerpt: "当年播出反响平平，如今被网友逐帧考古翻红。评论区清一色“当年怎么没发现这神场面”。",
    time: "周一 20:33",
    heat: "7.9w",
    trend: true,
    fresh: false,
    img: "https://readdy.ai/api/search-image?query=editorial%20illustration%20of%20scattered%20newspaper%20clippings%20with%20torn%20edges%20and%20a%20paper%20airplane%20flying%20over%20them%20on%20a%20soft%20cream%20background%20subtle%20film%20grain%20muted%20tomato%20red%20and%20warm%20gray%20accents%20no%20people%20no%20readable%20text%20soft%20lighting%20high%20detail%20magazine%20art&width=900&height=600&seq=feed-news-06&orientation=landscape",
  },
  {
    id: 8,
    cat: "明星",
    title: "粉丝经济数据局：一个月登顶热度榜的艺人，到底做对了什么",
    excerpt: "作品之外，营业节奏、人设颗粒度与数据运营缺一不可。这份拆解把“如何被看见”讲得明明白白。",
    time: "周一 11:09",
    heat: "6.8w",
    trend: false,
    fresh: true,
    img: "https://readdy.ai/api/search-image?query=editorial%20illustration%20of%20a%20rising%20popularity%20trend%20line%20chart%20with%20flame%20icons%20and%20star%20sparkles%20drawn%20on%20warm%20paper%20on%20a%20soft%20cream%20background%20subtle%20film%20grain%20muted%20tomato%20red%20and%20orange%20accents%20no%20people%20no%20text%20soft%20lighting%20high%20detail%20magazine%20art&width=900&height=600&seq=feed-trend-08&orientation=landscape",
  },
];

export const rankList: RankItem[] = [
  { id: 1, title: "《全员躲猫猫》录制现场名场面完整复盘", cat: "综艺", heat: "9.6w", delta: "+18", up: true },
  { id: 2, title: "红毯合照站位玄学：C 位背后的门道", cat: "明星", heat: "8.8w", delta: "+9", up: true },
  { id: 3, title: "恋综导师神预言被逐条应验", cat: "情感", heat: "8.1w", delta: "+12", up: true },
  { id: 4, title: "被遗忘三年的神级现场翻红史", cat: "综艺", heat: "7.9w", delta: "-3", up: false },
  { id: 5, title: "杀青一年才定档：结局改了三次", cat: "影视", heat: "7.2w", delta: "+5", up: true },
];

export const pillars: Pillar[] = [
  { icon: "ri-lock-unlock-line", title: "免费全解锁，无门槛", text: "不用注册、不用付费，点开即看。吃瓜免费资源每日更新，热门瓜料常看常有，畅享零门槛。" },
  { icon: "ri-stack-line", title: "一站聚合，不用到处找", text: "把散落在各平台的综艺、红毯、影视、直播热门内容汇到一个页面，一个页面全搞定，告别多站切换。" },
  { icon: "ri-refresh-line", title: "更新勤快，随时可看", text: "爆点一到马上上菜，热门内容实时跟进。无论白天深夜，想吃的瓜这里基本都有热乎的。" },
  { icon: "ri-flashlight-line", title: "标题直给，不玩标题党", text: "标题怎么说内容怎么来，配图克制不夸张。帮你把时间花在真正的料上，而不是一次次被标题钓着走。" },
];

export const quotes: Quote[] = [
  { name: "小瓜不苦", role: "天天追综艺", text: "以前要开好几个 App 来回切，现在一个页面就能把当天的名场面看全，省心多了。" },
  { name: "吃瓜群众甲", role: "热衷明星红毯", text: "标题很直给，点开果然就是我想看的，没被标题党骗过的体验真的舒服。" },
  { name: "夜猫子上线", role: "深夜冲浪党", text: "半夜两点也能刷到热乎的，更新是真的快，热门内容随时看这点说到做到。" },
];

export const faqs: Faq[] = [
  { q: "为什么能一直免费，不需要付费解锁？", a: "吃瓜免费资源本来就是面向大众免费开放的合集，我们不设会员墙、不搞单篇付费。页面以公益分享与娱乐聚合为目标，靠合理的内容编排把开销压到最低，所以能持续做到免费全解锁、无门槛畅享。" },
  { q: "内容多久更新一次，会错过热点吗？", a: "热门内容实时跟进，出现爆点后我们会在第一时间补上榜单与卡片。同时提供“最新”排序和全时段跟进，即使错过当天的推送，稍后回来也能在页面里快速补齐。" },
  { q: "页面上的内容都来自哪里，靠谱吗？", a: "内容以公开渠道可检索的信息为素材，进行整理与聚合展示，不做添油加醋的原创爆料。凡涉及娱乐性质的讨论均会注明，帮助你在参考时保持理性判断。" },
  { q: "是否需要注册账号或登录才能看？", a: "不需要。本页为纯静态展示，所有瓜料点开即看，无需注册、登录或提交任何个人信息，真正做到零门槛。" },
  { q: "在手机上浏览体验如何？", a: "页面已针对手机端做了自适应优化，卡片流、榜单与阅读区域在小屏上会重新排布，横竖屏都能顺畅浏览，通勤路上也能安心吃瓜。" },
];